(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exports(
            require('./metric.js'),
            require('./search.js'),
            require('../../metrics/defaults.js'),
            require('../../metrics/crossChannel.js'),
            require('../../enums/metrics.js'),
            require('lodash')
        );

    } else {
        RivalIQ.metric.property = exports(
            RivalIQ.metric,
            RivalIQ.metric.search,
            RivalIQ.metrics.defaults,
            RivalIQ.metrics.definitions.crossChannel,
            RivalIQ.enums,
            window._
        );
    }

    function exports(metricFn, searchFn, defaults, definitions, metricEnums, _) {

        function metricType(metric) {
            return searchFn.getPropertyValue(metric, 'metricType');
        }

        function metricValueType(metric) {
            return searchFn.getPropertyValue(metric, 'metricValueType');
        }

        function type(metric) {
            if (_.isUndefined(metric.type)) {
                return searchFn.getPropertyValue(metric, 'type');
            }

            return metric.type;
        }

        function source(metric) {
            return searchFn.getPropertyValue(metric, 'source');
        }

        function isNumeric(metric) {
            // NOTE/TODO unfortunately `type` does not behave correctly when
            // `property` is `name`, so we have to special case its exclusion
            // from numerality here... see #14845
            return (metric.property !== 'name') && _.includes([
                metricEnums.dataType.INTEGER,
                metricEnums.dataType.NUMERIC,
                metricEnums.dataType.CURRENCY,
                metricEnums.dataType.ABSOLUTE_PERCENT,
                metricEnums.dataType.DURATION_SECONDS,
                metricEnums.dataType.DURATION_MILLIS
            ], type(metric));
        }

        function isPrivate(metric) {
            const src = source(metric);
            return Boolean(metricEnums.sourceDetails[src].privateData);
        }

        function isSummable(property) {
            const valueType = _.get(definitions[property], 'metricValueType');
            const dataType = _.get(definitions[property], 'type');

            return valueType !== metricEnums.metricValueType.AVERAGE &&
                dataType !== metricEnums.dataType.STRING &&
                dataType !== metricEnums.dataType.ABSOLUTE_PERCENT &&
                dataType !== metricEnums.dataType.DURATION_SECONDS &&
                dataType !== metricEnums.dataType.DURATION_MILLIS;
        }

        function get(key) {
            return definitions[key];
        }

        function set(key, value) {
            definitions[key] = value;
        }

        function hasEnoughDataKey(metric) {
            if (isPrivate(metric)) {

                const enoughDataKey = searchFn.getPropertyValue(metric, 'enoughDataKey');

                if (enoughDataKey) {
                    return `Private${_.capitalize(enoughDataKey)}Data`;
                }

                return (searchFn.getPropertyValue(metric, 'noHistoricData') ? 'PrivatePresenceData' : 'PrivatePostData');
            } else {
                return (searchFn.getPropertyValue(metric, 'noHistoricData') ? 'PresenceData' : 'PostData');
            }
        }

        function getEnoughDataKey(metric) {
            if (isPrivate(metric)) {
                return searchFn.getPropertyValue(metric, 'enoughDataKey');
            }
        }

        return {
            isSummable: isSummable,
            get: get,
            set: set,
            metricType: metricType,
            metricValueType: metricValueType,
            type: type,
            isNumeric: isNumeric,
            isPrivate: isPrivate,
            hasEnoughDataKey: hasEnoughDataKey,
            getEnoughDataKey: getEnoughDataKey,
            source: source
        };
    }
})();
